import { AutoMap } from "@automapper/classes"

export class Portfolio {
    @AutoMap()
    SamplingPointCode: string = ''
    @AutoMap()
    SamplingPointName: string = ''
    @AutoMap()
    SamplingPointAddress: string = ''
    @AutoMap()
    SamplingPointAdditionalAddress: string = ''
    @AutoMap()
    SamplingPointCity: string = ''
    @AutoMap()
    SamplingPointZipCode: string = ''
    @AutoMap()
    ClientCode: string = ''
    @AutoMap()
    ClientName: string = ''
    @AutoMap()
    PartnerCode: string = ''

    public constructor(init?: Partial<Portfolio>) {
        Object.assign(this, init);
    }
}